export const environment = {
  production: true,
  env: 'dev',
  authLoginUrl: 'https://idm.dev.zsservices.com/CTFO-Asset/IdentityManager/app/Web/login.aspx?ReturnUrl=',
  authLogOutUrl: 'https://idm.dev.zsservices.com/CTFO-Asset/IdentityManager/app/Web/logout.aspx',
  staticJSON: false,
  forceServeStaticDataFor: [],
};

